import { createContext, useContext } from 'react';
import type { Session } from '@supabase/supabase-js';
import type { Profile } from '../../lib/supabaseClient';

export interface AuthContextType {
  session: Session | null;
  profile: Profile | null;
  loading: boolean;
  role: 'superadmin' | 'photographer' | 'client' | null;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
}
